module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-300.70e4020c8c2da472b5ce.svg";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.svg
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.svg
// module chunks = styles